/** Matches `ADS_MANAGER_LAYOUT_MAX_WIDTH_PX` in production `PostAdoptionLayout.tsx`. */
export const ADS_MANAGER_LAYOUT_MAX_WIDTH_PX = 1580;

/** Below this width, stacked / single-column layouts kick in. */
export const STACK_LAYOUT_BREAKPOINT_PX = 733;

/** Production moves the primary CTA to its own row below this width; this prototype keeps it right-aligned. */
export const EXTRA_ROW_CTA_BREAKPOINT_PX = 1400;

/** BrandLayout tablet breakpoint. */
export const BRAND_LAYOUT_TABLET_BREAKPOINT_PX = 600;

/** BrandLayout desktop breakpoint. */
export const BRAND_LAYOUT_DESKTOP_BREAKPOINT_PX = 1024;

/** Max width for General / Advanced settings tab body content. */
export const ADS_SETTINGS_BODY_MAX_WIDTH_PX = 1040;

/**
 * Page surface: the left nav, the header chrome, and the scroll body behind the
 * cards. Cards, tables, and charts stay white so they read as raised against it.
 */
export const ADS_MANAGER_SURFACE_CLASS = "bg-[#fbfbf9]";

/**
 * Every data row in every table is this tall, so tables stacked on a page (or
 * sitting side by side) share a rhythm. 60px is the tallest row the prototype
 * already had — the month table's two-line cells and the Products row's 36px
 * thumbnail both land there — so nothing had to get shorter. Cells keep their
 * own padding as a minimum and center what's left.
 */
export const TABLE_ROW_HEIGHT_CLASS = "h-[60px]";

/** Horizontal padding aligned with BrandLayout (16px → 32px → 40px). */
export const ADS_MANAGER_CONTENT_PADDING_CLASS =
  "px-4 min-[600px]:px-8 min-[1024px]:px-10";

/** Max-width shell shared by header, tabs, and tab content. */
export const ADS_MANAGER_CONTENT_SHELL_CLASS =
  "mx-auto w-full max-w-[1580px] px-4 min-[600px]:px-8 min-[1024px]:px-10";

/** Stack filter rows and toolbars below 733px. */
export const ADS_MANAGER_STACK_ROW_CLASS =
  "flex flex-col min-[733px]:flex-row min-[733px]:flex-wrap gap-2";

/** Centered body column for Advertising settings tabs. */
export const ADS_SETTINGS_BODY_CLASS =
  "mx-auto flex w-full max-w-[1040px] flex-col";
